import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../assets/styles/themes/tokens';

interface DashboardPageHeaderProps {
  firstName?: string;
}

const DashboardPageHeader: React.FC<DashboardPageHeaderProps> = ({ firstName }) => {
  const { t } = useTranslation();
  
  return (
    <Typography 
      variant='h5' 
      sx={{ color: palette.text.primary }}>
      { firstName ? `${t('Welcome back')}, ${firstName}` : t('Welcome back') }
    </Typography>
  );
};

export default DashboardPageHeader;
